import { render, staticRenderFns } from "./WaybillPDF.vue?vue&type=template&id=99390d7c&scoped=true&"
import script from "./WaybillPDF.vue?vue&type=script&lang=js&"
export * from "./WaybillPDF.vue?vue&type=script&lang=js&"
import style0 from "./WaybillPDF.vue?vue&type=style&index=0&id=99390d7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99390d7c",
  null
  
)

export default component.exports